import ReportService from "../services/report.service";

export async function getReportByDate(fleet_id, from, to) {
  try {
    const response = await ReportService.getReportByDateService(
      fleet_id,
      from === null ? new Date() : from,
      to === null ? "" : to
    );

    return Promise.resolve(response.data);
  } catch (err) {
    console.error(err);
    return Promise.resolve({ error: err });
  }
}
